<template>
  <div class="min-h-screen flex flex-col justify-center items-center pt-6 sm:pt-0 p-4">
    <logo></logo>

    <div class="w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden rounded-lg">
      <div v-if="success" class="mb-4 p-4 bg-green-100 border border-green-400 text-green-700 rounded">
        Een wachtwoord reset link is verstuurd naar uw e-mailadres.
      </div>
      <form @submit.prevent="resetPassword" v-else>
        <div>
          <label class="block font-medium text-sm text-gray-500" for="email">
            Email
          </label>
          <input v-model="email"
            class="p-2 rounded-md shadow-sm bg-white border border-gray-300 text-gray-400 block mt-1 w-full" id="email"
            type="email" name="email" required="required" autofocus="autofocus">
        </div>
        <div v-if="errors" class="text-red-500 py-2 font-semibold">
          <div v-if="errors.message">{{ errors.message }}</div>
          <div v-if="errors.errors">
            <div v-for="(error, field) in errors.errors" :key="field">
              {{ error[0] }}
            </div>
          </div>
        </div>
        <div class="flex items-center justify-end mt-4">
          <button type="submit" :disabled="loading"
            class="inline-flex items-center px-4 py-2 bg-gray-900 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring ring-gray-300 disabled:opacity-25 transition ease-in-out duration-150 ml-3">
            {{ loading ? 'Versturen...' : 'Stuur wachtwoord reset' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue'

export default {
  data: () => {
    return {
      email: null,
      errors: null,
      success: false,
      loading: false,
    }
  },
  components: {
    Logo,
  },
  methods: {
    resetPassword() {
      this.errors = null
      this.loading = true
      axios.post('/forgot-password', { email: this.email })
        .then((response) => {
          this.success = true
          this.loading = false
        })
        .catch((error) => {
          // Always show success message for security (don't reveal if email exists)
          this.success = true
          this.loading = false
        })
    }
  }
}
</script>
